module.exports = __webpack_public_path__ + "img/delete-solid.f26a8282.svg";